import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { ShareLinkPage } from '@/features/files';

function FolderShareRoute(): ReactNode {
  const { folderId } = Route.useParams();
  return (
    <AuthGuard>
      <ShareLinkPage kind="folder" id={folderId} />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/library_/folders/$folderId/share')({
  component: FolderShareRoute,
});
